import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { setAuthToken } from "../lib/axiosAuth";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Determine where to redirect a user based on their registration status.
 */
function getRedirectPath(user) {
  // Superadmin → superadmin dashboard (always, regardless of org)
  if (user.role === "superadmin") return "/superadmin";

  // Check registration_step
  const step = user.registration_step;
  if (step === "complete" || (user.organization_id && !step)) {
    return "/dashboard";
  }

  if (!user.organization_id) {
    // No org → needs to create one
    return "/register/organization";
  }

  if (step === "user_created") {
    return "/register/organization";
  }

  if (step === "org_created") {
    return "/register/plan";
  }

  // Fallback: if org exists but step is unclear, go to dashboard
  return "/dashboard";
}

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "?")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        // Safari ITP fallback: persist Bearer token alongside the cookie.
        if (res.data?.session_token) setAuthToken(res.data.session_token);
        setUser(res.data);
        const redirectPath = getRedirectPath(res.data);
        navigate(redirectPath, { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-teal-400 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-400">Authenticando...</p>
      </div>
    </div>
  );
}
